import React, { useState } from 'react';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Box, IconButton } from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import { MessageContentWithSources } from '../../TextMessage';
import { SourceCard } from '../SourceCard';
import styles from './ContentWithIndexedSources.module.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const CN = 'content-with-indexed-sources';
const sourcesClass = `${CN}__sources`;

interface ContentWithIndexedSourcesProps {
  messageContent: MessageContentWithSources;
}

export const ContentWithIndexedSources = ({ messageContent }: ContentWithIndexedSourcesProps): React.ReactElement => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { text, indexed_sources } = messageContent;
  const [ isOpen, setIsOpen ] = useState(false);

  return (
    <>
      {indexed_sources?.map((currentSources, index) => {
        const startIndex = index === 0 ? 0 : indexed_sources[index - 1].index;
        const endIndex = currentSources.index;

        return (
          <Box key={ index } className={ cx(CN) }>
            <Markdown remarkPlugins={ [ remarkGfm ] }>
              {text?.slice(startIndex, endIndex)}
            </Markdown>
            <IconButton size='small' color='info' sx={ { my: '-5px' } } onClick={ (): void => setIsOpen(prev => !prev) }>
              <LinkIcon fontSize='small' />
            </IconButton>
            {isOpen && (
              <Box className={ cx(sourcesClass) }>
                {currentSources.items.map((item, index) => (<SourceCard source={ item } withBorder key={ index } />))}
              </Box>
            )}
            {index === indexed_sources.length - 1 && (
              <Markdown remarkPlugins={ [ remarkGfm ] }>
                {text?.slice(endIndex)}
              </Markdown>
            )}
          </Box>
        );
      })}
    </>
  );
};
